export default "__VITE_ASSET__DQwAUfSg__"